import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RegisterService {

  constructor(private httpClient: HttpClient) { }



  aadharOTP(data: any) {
    return this.httpClient.post(`${environment?.ApiURL}register/farmer/aadhaar/otp/generate`, data)
  }

  verifyOTP(data: any) {
    return this.httpClient.post(`${environment?.ApiURL}register/farmer/aadhaar/otp/verify`, data)
  }

  verifyFarmerAccount(data: any) {
    return this.httpClient.post(`${environment?.ApiURL}register/bankaccount/verify`, data)
  }

  //Center
  getCenter() {
    return this.httpClient.get(`${environment.ApiURL}group?GroupType=CENTER&ApprovalStatus=PENDING&ApprovalStatus=APPROVED&ApprovalStatus=REJECTED&IsActive=true&IsActive=false`)
  }

  getCenterByID(id: any) {
    return this.httpClient.get(`${environment.ApiURL}group/${id}`)
  }


  addCenter(id: any, data: any) {
    return this.httpClient.post(`${environment.ApiURL}Register/client/${id}/center`, data)
  }

  updateCenter(id: any, data: any) {
    // return this.httpClient.put(`${environment.ApiURL}group/update/${id}`, data)
    return this.httpClient.put(`${environment.ApiURL}group/centerupdate/${id}`, data)

  }

  deleteCenter(id: any, comment: any) {
    return this.httpClient.delete(`${environment.ApiURL}group/${id}/center?comment=${comment}`)
  }

  //Client

  getClient() {
    return this.httpClient.get(`${environment.ApiURL}group?GroupType=CLIENT&ApprovalStatus=PENDING&ApprovalStatus=APPROVED&ApprovalStatus=REJECTED`)
  }

  addClient(data: any) {
    return this.httpClient.post(`${environment.ApiURL}Register/client`, data)
  }
  getClientList() {
    return this.httpClient.get(`${environment.ApiURL}group?GroupType=CLIENT&ApprovalStatus=PENDING&ApprovalStatus=APPROVED&ApprovalStatus=REJECTED`)
  }
  getClientById(id: any) {
    return this.httpClient.get(`${environment.ApiURL}group/${id}`)
  }
  deleteClient(id: any, cmt: any) {
    return this.httpClient.delete(`${environment.ApiURL}group/${id}?comment=${cmt}`)
  }

  //Warehouse
  getWarehouse(path: any = '') {
    return this.httpClient.get(`${environment.ApiURL}warehouse/getlist?ApprovalStatus=PENDING&ApprovalStatus=APPROVED&ApprovalStatus=REJECTED&IsActive=true&IsActive=false${path}`)
  }

  getWarehouseByID(id: any) {
    return this.httpClient.get(`${environment.ApiURL}warehouse/${id}`)
  }


  addWarehouse(id: any, data: any) {
    return this.httpClient.post(`${environment.ApiURL}warehouse/${id}`, data)
  }

  updateWarehouse(id: any, data: any) {
    return this.httpClient.put(`${environment.ApiURL}warehouse/update/${id}`, data)
  }

  deleteWarehouse(id: any, comment: any) {
    return this.httpClient.delete(`${environment.ApiURL}WareHouse/delete/${id}?comment=${comment}`)
  }

  //Farmer
  addFarmer(id: any, data: any) {
    return this.httpClient.post(`${environment.ApiURL}farmer/${id}`, data)
  }
  updateFarmer(id: any, data: any) {
    return this.httpClient.put(`${environment.ApiURL}farmer/update/farmer/${id}`, data)
  }
  addFarmerWithoutId(data: any) {
    return this.httpClient.post(`${environment.ApiURL}farmer/add/farmer`, data)
  }

  getFarmer(queryString: any) {
    return this.httpClient.get(`${environment.ApiURL}farmer?ApprovalStatus=PENDING&ApprovalStatus=APPROVED&ApprovalStatus=REJECTED&IsActive=true&IsActive=false&${queryString}`)
  }

  getFarmerListByCenterId(id: any) {
    return this.httpClient.get(`${environment.ApiURL}farmer/farmerbycenter/${id}`)
  }

  getFarmerByID(id: any) {
    return this.httpClient.get(`${environment.ApiURL}farmer/${id}`)
  }

  getFarmerBank(id: any) {
    return this.httpClient.get(`${environment.ApiURL}farmer/${id}/bankaccount`)
  }

  getFarmerLand(id: any) {
    return this.httpClient.get(`${environment.ApiURL}farmer/${id}/landdetail`)
  }

  getLandByFarmerId(id: any) {
    return this.httpClient.get(`${environment.ApiURL}farmer/${id}/landdetail`)
  }
  updateFarmerLand(id: any, data: any) {
    return this.httpClient.put(`${environment.ApiURL}farmer/update/farmer/land/detail/${id}`, data)
  }
  addLandByFarmerId(id: any, data: any) {
    return this.httpClient.post(`${environment.ApiURL}farmer/add/landdetails/${id}`, data)
  }
  deleteFarmerLand(id: any) {
    return this.httpClient.delete(`${environment.ApiURL}farmer/land/delete/${id}`)
  }
  deleteFarmer(id: any) {
    return this.httpClient.delete(`${environment.ApiURL}farmer/delete/${id}`)
  }

  getLandType() {
    return this.httpClient.get(`${environment.ApiURL}enum/LandType`)
  }

  //IFSC
  getIfsc(id: any) {
    return this.httpClient.get(`${environment.ApiURL}static/bank/ifsc/${id}`)
  }

  // Target Allotment
  addTargetAllotment(centerId: any, data: any) {
    return this.httpClient.post(`${environment.ApiURL}center/target/${centerId}`, data)
  }
  getTargetAllotment() {
    return this.httpClient.get(`${environment.ApiURL}center/target?ApprovalStatus=PENDING`)
  }
  getTargetAllotmentById(id: any) {
    return this.httpClient.get(`${environment.ApiURL}center/target/${id}`)
  }
  getTargetAllotmentByCommodityID(id: any) {
    return this.httpClient.get(`${environment.ApiURL}center/target?CommodityId=${id}&ApprovalStatus=PENDING&ApprovalStatus=APPROVED&ApprovalStatus=REJECTED`)
  }

  deleteTargetAllotment(id: any, comment: any) {
    return this.httpClient.delete(`${environment.ApiURL}center/target/${id}?comment=${comment}`)
  }

  // Target Assign Farmer
  assignTargetToFarmer(data: any) {
    return this.httpClient.post(`${environment.ApiURL}target/assign/farmer`, data)
  }
  getAssignTargetFarmer(id: any) {
    return this.httpClient.get(`${environment.ApiURL}target/assign/farmer/get/by/${id}`)
  }

  getAssignTargetFarmer2() {
    return this.httpClient.get(`${environment.ApiURL}target/assign/farmer/center/farmer?ApprovalStatus=PENDING&ApprovalStatus=APPROVED&ApprovalStatus=REJECTED`)
  }
  deleteAssignTargetFarmer(id: any, comment: any) {
    return this.httpClient.delete(`${environment.ApiURL}target/assign/farmer/${id}?comment=${comment}`)
  }

  // Farmer Distribution
  addFarmerDistribution(data: any) {
    return this.httpClient.post(`${environment.ApiURL}farmer/distribution`, data)
  }

  getFarmerDistribution() {
    return this.httpClient.get(`${environment.ApiURL}farmer/distribution?ApprovalStatus=PENDING`)
  }
  getFarmerDistributionOwnType() {
    return this.httpClient.get(`${environment.ApiURL}farmer/distribution?GroupBy=CLIENT&GroupBy=CENTER&ApprovalStatus=PENDING&ApprovalStatus=APPROVED&ApprovalStatus=REJECTED&IsActive=true&IsActive=false`)
  }
  getPlantingMaterial() {
    return this.httpClient.get(`${environment.ApiURL}enum/PlantingMaterial`)
  }
  getAgriInputDistributionById(id: any) {
    return this.httpClient.get(`${environment.ApiURL}farmer/distribution/${id}`)
  }
  getAgriInputDistributionByCenterId(id: any) {
    return this.httpClient.get(`${environment.ApiURL}farmer/distribution?GroupBy=CLIENT&GroupBy=CENTER&CenterTargetId=${id}&ApprovalStatus=PENDING&ApprovalStatus=APPROVED&ApprovalStatus=REJECTED&IsActive=true&IsActive=false`)
  }
  getNamebyIdAssignFarmer(id: any) {
    return this.httpClient.get(`${environment.ApiURL}target/assign/farmer/${id}`)
  }
  getDistributedFarmerByFarmerId(id: any) {
    return this.httpClient.get(`${environment.ApiURL}farmer/distribution/farmer/${id}`)
  }
  billGenerate(id: any) {
    return this.httpClient.get(`${environment.ApiURL}static/generate/billno/${id}`)
  }

  getTargetAllotmentDetails() {
    return this.httpClient.get(`${environment.ApiURL}center/target?ApprovalStatus=PENDING&ApprovalStatus=APPROVED&ApprovalStatus=REJECTED`)
  }
  getFarmerTargetAllotmentbyCenterId(id: any) {
    return this.httpClient.get(`${environment.ApiURL}target/assign/farmer/center/farmer?CenterTargetId=${id}&GroupBy=CLIENT&GroupBy=CENTER&ApprovalStatus=PENDING&ApprovalStatus=APPROVED&ApprovalStatus=REJECTED
      `)
  }
  updateAgriInputDistribution(id: any, data: any) {
    return this.httpClient.put(`${environment.ApiURL}farmer/distribution/update/${id}`, data)
  }
  deleteAgriInputDistribution(id: any, comment: any) {
    return this.httpClient.delete(`${environment.ApiURL}farmer/distribution/delete/${id}?comment=${comment}`)
  }
  // Role
  getUserRoles() {
    return this.httpClient.get(`${environment.ApiURL}role`)
  }

  // Type
  getUserType() {
    return this.httpClient.get(`${environment.ApiURL}role/user/permission/enum`)
  }

  // Register Assayer

  registerAssayer(data: any) {
    return this.httpClient.post(`${environment.ApiURL}user/add/assayeradmin`, data)
  }
  registerAssayerByCenterAdmin(id: any, data: any) {
    return this.httpClient.post(`${environment.ApiURL}user/add/${id}/assayeruser`, data)
  }


  getAssayerlist() {
    return this.httpClient.get(`${environment.ApiURL}user/list?UserType=GRADEUSER&UserType=CENTERADMIN&ApprovalStatus=PENDING&ApprovalStatus=APPROVED&ApprovalStatus=REJECTED&IsActive=true&IsActive=false`)
  }
  getAssayerById(id: any) {
    return this.httpClient.get(`${environment.ApiURL}user/ById/${id}`)
  }
  updateAssayer(id: any, data: any) {
    return this.httpClient.put(`${environment.ApiURL}user/update/user/${id}`, data)
  }

  // Register User
  registerUser(data: any) {
    return this.httpClient.post(`${environment.ApiURL}user/add/user/login/base`, data)
  }

  registerUserById(id: any, data: any,) {
    return this.httpClient.post(`${environment.ApiURL}user/add/user/${id}`, data)
  }

  getUser() {
    // return this.httpClient.get(`${environment.ApiURL}user/list?ApprovalStatus=PENDING&ApprovalStatus=APPROVED&ApprovalStatus=REJECTED&IsActive=true&IsActive=false`)

    return this.httpClient.get(`${environment.ApiURL}user/list?Role=AGUSER&Role=AGVIEWER&Role=CLIENTUSER&Role=CLIENTVIEWER&Role=CENTERUSER&Role=CENTERVIEWER&Role=WAREHOUSEADMIN&Role=WAREHOUSEUSER&Role=WAREHOUSEVIEWER&Role=ACCOUNTANT&Role=SEEDPROCESSINGOPERATOR&ApprovalStatus=PENDING&ApprovalStatus=APPROVED&ApprovalStatus=REJECTED&IsActive=true&IsActive=false`)
  }

  getUserById(id: any) {
    return this.httpClient.get(`${environment.ApiURL}user/ById/${id}`)
  }

  updateUser(id: any, data: any) {
    return this.httpClient.put(`${environment.ApiURL}user/update/user/${id}`, data)
  }

  updateUserStatus(id: any, data: any) {
    return this.httpClient.put(`${environment.ApiURL}user/${id}/activation`, data)
  }


  // Register Bag

  getBag() {
    return this.httpClient.get(`${environment.ApiURL}bag/list?ApprovalStatus=PENDING&ApprovalStatus=APPROVED&ApprovalStatus=REJECTED&IsActive=true&IsActive=false`)
  }

  addbag(data: any) {
    return this.httpClient.post(`${environment.ApiURL}bag/add`, data)
  }

  deleteBag(id: any) {
    return this.httpClient.delete(`${environment.ApiURL}bag/delete?Id=${id}`)
  }

  updateBag(id: any, data: any) {
    return this.httpClient.put(`${environment.ApiURL}bag/update/${id}`, data)
  }

  // Register Class Seed
  getClassSeed() {
    return this.httpClient.get(`${environment.ApiURL}class/seed?ApprovalStatus=PENDING&ApprovalStatus=APPROVED&ApprovalStatus=REJECTED&IsActive=true&IsActive=false`)
  }

  addClassSeed(data: any) {
    return this.httpClient.post(`${environment.ApiURL}class/seed`, data)
  }

  deleteClassSeed(id: any, comment: any) {
    return this.httpClient.delete(`${environment.ApiURL}class/seed/${id}?comment=${comment}`)
  }

  updateClassSeed(id: any, data: any) {
    return this.httpClient.put(`${environment.ApiURL}class/seed/${id}`, data)
  }

  //  agreement
  getAgreement() {
    return this.httpClient.get(`${environment.ApiURL}agreement/list?ApprovalStatus=PENDING&ApprovalStatus=APPROVED&ApprovalStatus=REJECTED&IsActive=true&IsActive=false`)
  }
  getAgreementById(id: any) {
    return this.httpClient.get(`${environment.ApiURL}agreement/${id}`)
  }

  getAgreementByCenter(id: any) {
    return this.httpClient.get(`${environment.ApiURL}agreement/list?ApprovalStatus=PENDING&ApprovalStatus=APPROVED&ApprovalStatus=REJECTED&IsActive=true&IsActive=false&CenterId=${id}`)
  }

  updateAgreement(id: any, data: any) {
    return this.httpClient.put(`${environment.ApiURL}agreement/update/${id}`, data)
  }
  nomineeByAgreementId(id: any) {
    return this.httpClient.get(`${environment.ApiURL}nominees/agreement/${id}`)
  }
  updateNominee(id: any, data: any) {
    return this.httpClient.put(`${environment.ApiURL}nominee/update/${id}`, data)
  }
  updateWitness(id: any, data: any) {
    return this.httpClient.put(`${environment.ApiURL}witness/update/${id}`, data)
  }
  witnessByAgreementId(id: any) {
    return this.httpClient.get(`${environment.ApiURL}witness/agreement/${id}`)
  }


  getUserSelf() {
    return this.httpClient.get(`${environment.ApiURL}user/self`)
  }

  // Inspection

  getInspection() {
    return this.httpClient.get(`${environment.ApiURL}inspection?ApprovalStatus=PENDING&ApprovalStatus=APPROVED&ApprovalStatus=REJECTED&IsActive=true&IsActive=false`)
  }
  InspectionDelete(id: any, comment: any) {
    return this.httpClient.delete(`${environment.ApiURL}inspection/delete/${id}?comment=${comment}`)
  }
  getInspectionById(id: any) {
    return this.httpClient.get(`${environment.ApiURL}inspection/${id}`)
  }
  getInspectionByAgreementId(id: any) {
    return this.httpClient.get(`${environment.ApiURL}inspection?AgreementCode=${id}&ApprovalStatus=PENDING&ApprovalStatus=APPROVED&ApprovalStatus=REJECTED&IsActive=true&IsActive=false`)
  }

  // Seed Processing Plant

  getProcessingPlant() {
    return this.httpClient.get(`${environment.ApiURL}processingplant/list?ApprovalStatus=PENDING&ApprovalStatus=APPROVED&ApprovalStatus=REJECTED&IsActive=true&IsActive=false`)
  }

  getProcessingPlantByID(id: any) {
    return this.httpClient.get(`${environment.ApiURL}processingplant/${id}`)
  }

  addProcessingPlant(id: any, data: any) {
    return this.httpClient.post(`${environment.ApiURL}processingplant/${id}`, data)
  }

  addProcessingPlantByCenter(data: any) {
    return this.httpClient.post(`${environment.ApiURL}processingplant/center`, data)
  }

  updateProcessingPlant(id: any, data: any) {
    return this.httpClient.put(`${environment.ApiURL}processingplant/update${id}`, data)
  }

  deleteProcessingPlant(id: any, comment: any) {
    return this.httpClient.delete(`${environment.ApiURL}processingplant/delete/${id}?comment=${comment}`)
  }


  // Committee Member

  getCommitteeMember() {
    return this.httpClient.get(`${environment.ApiURL}processingplant/list?ApprovalStatus=PENDING&ApprovalStatus=APPROVED&ApprovalStatus=REJECTED&IsActive=true&IsActive=false`)
  }

  getCommitteeMemberByID(id: any) {
    return this.httpClient.get(`${environment.ApiURL}processingplant/${id}`)
  }

  addCommitteeMember(data: any) {
    return this.httpClient.post(`${environment.ApiURL}processingplant`, data)
  }

  deleteCommitteeMember(id: any, comment: any) {
    return this.httpClient.delete(`${environment.ApiURL}processingplant/delete/${id}?comment=${comment}`)
  }

  updateCommitteeMember(id: any, data: any) {
    return this.httpClient.put(`${environment.ApiURL}processingplant/update${id}`, data)
  }

}
